/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-action="load-more"]');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.classList.contains('is-loading')) {
      return;
    }

    var section = button.closest('[data-section-type="collection"]');
    var productList = section && section.querySelector('.product-list--collection');
    var pagination = button.closest('.collection-pagination');

    if (!section || !productList || !pagination) {
      window.location.href = button.href;
      return;
    }

    var nextUrl = new URL(button.href, window.location.origin);
    var sectionId = section.getAttribute('data-section-id');
    var sectionUrl = nextUrl.search
      ? nextUrl.pathname + '/' + nextUrl.search + '&section_id=' + sectionId
      : nextUrl.pathname + '?section_id=' + sectionId;

    button.classList.add('is-loading');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(sectionUrl, {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function(response) {
      return response.text();
    }).then(function(content) {
      var tempElement = document.createElement('div');
      tempElement.innerHTML = content;

      var nextList = tempElement.querySelector('.product-list--collection');
      var nextPagination = tempElement.querySelector('.collection-pagination');

      if (nextList) {
        Array.prototype.slice.call(nextList.children).forEach(function(item) {
          productList.appendChild(item);
        });
      }

      if (nextPagination) {
        pagination.replaceWith(nextPagination);
      } else {
        pagination.remove();
      }

      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    }).catch(function() {
      button.classList.remove('is-loading');
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
    });
  });
})();


